export const getPurchaseInvalidationDescriptions = (
  hasDocumentType: boolean,
  isExcludedSubject: boolean
) => {
  const dataDescription = !hasDocumentType
    ? 'Seleccione el motivo de anulación. Si el documento es Sujeto Excluido (14), ingrese el Código de Generación del DTE.'
    : isExcludedSubject
    ? 'Seleccione el motivo de anulación. El Código de Generación del DTE es obligatorio para Sujeto Excluido (14).'
    : 'Seleccione el motivo de anulación. Para este tipo de documento no necesita ingresar Código de Generación.';

  const reasonDescription = !hasDocumentType
    ? 'Explique de forma clara y concisa el motivo de la anulación. Este texto se registrará en el historial del documento y, cuando aplique DTE, también se enviará al Ministerio de Hacienda.'
    : isExcludedSubject
    ? 'Explique de forma clara y concisa el motivo de la anulación. Este texto será enviado al Ministerio de Hacienda.'
    : 'Explique de forma clara y concisa el motivo de la anulación. Este texto quedará registrado en el historial del documento.';

  return {
    dataDescription,
    reasonDescription,
  };
};